export const PACK_SIZE_MESSAGE =
  'Number of Pack Units in a Purchase Unit (e.g. CASE = 6 CAN)';
export const DEFAULT_ACCOUNT_CATEGORY_ID = 15;
export const BRACKET_PRICING_PLACEHOLDER = 'BRACKET';



// WEBPACK FOOTER //
// ./src/common/Constants/inventory.js